<template>
  <div>
    <h2 v-if="this.studentName">We drafted <span class="student-name fs-block">{{ studentName }}'s</span> present levels based on the information you provided.</h2>
    <p
      class="tab-description text-muted text-center"
      v-html="this.tabDescription"/>
    <div class="col">
      <nav>
        <ul
          class="nav nav-tabs"
          role="tablist">
          <li
            v-for="tab of tabs.visible"
            :class="{'active': tab === tabs.active, 'default': tab.default }"
            role="none"
            :key="tab.route">
            <router-link
              role="tab"
              :aria-controls="tab.route + 'TabPanel'"
              :aria-selected="tab === tabs.active ? 'true' : 'false'"
              aria-current-value="false"
              :to="{ name: tab.route, params: { uuid: $route.params.uuid } }"
              @click.native="clickedTab(tab)"
              :id="tab.route + 'Tab'"
            >{{ tab.label }} <AIBetaBadge v-if="tab.route === 'PresentlevelsConclusionGoalsStrategies'" class="ai-logo" /></router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import AIBetaBadge from '@/components/AIBetaBadge.vue';
import { mapState } from 'vuex'

export default {
  name: 'PresentLevelsConclusionTabs',
  components: {
    AIBetaBadge
  },
  props: {
    studentName: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('presentlevels', {
      tabs(state) {
        var AlignedGoalsLabel = 'Aligned Goals'
        const tabs = [
          {
            label: 'Present Levels Statement',
            route: 'PresentlevelsConclusion',
            eventName: 'Clicked Present Levels Conclusion Statement',
            default: true,
            isVisible: ()=> true
          },
          {
            label: 'Aligned Assessments',
            route: 'PresentlevelsConclusionAssessments',
            eventName: 'Clicked Aligned Assessments',
            isVisible: () => {
              const {resourceDocs} = state
              return resourceDocs && resourceDocs.length
            }
          },
          {
            label: AlignedGoalsLabel,
            route: 'PresentlevelsConclusionGoalsStrategies',
            eventName: 'Clicked Goals & Strategies',
            isVisible: ()=> true
          }
        ]
        const visible = tabs.filter(tab => tab.isVisible())
        const routedTab = tabs.find(tab => tab.route === this.$route.name)
        const defaultTab = tabs.find(tab => tab.default)
        return { visible, active: routedTab || defaultTab }
      }
    }),
    tabDescription() {
      switch (this.$route.name) {
        case 'PresentlevelsConclusionAssessments':
          return '<b>Save</b> or <b>download</b> the assessments below to collect student data that will inform your Present Levels Statement based on the information you provided.'
        case 'PresentlevelsConclusionGoalsStrategies':
          return '<b>Browse</b> learning goals, objectives, and progress monitoring assessments aligned to your student\'s Present Levels Statement.'
        default:
          return `<b>Copy</b> and <b>paste</b> the below information into your student's IEP, and edit based on your understanding of the student.
          To modify paragraphs about specific subject areas, or include additional subject areas, click "Edit Statements."`
      }
    }
  },
  methods: {
    clickedTab(tab) {
      this.$sendEvent(tab.eventName)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';
@accentColor: #1c5498;

.nav-tabs {
  padding-top: 16px;
  border-bottom: solid @accentColor 4px;
  margin-bottom: 16px;
  display: flex;
  align-items: flex-end;

  li {
    width: 33.33%;
    text-align: center;
    margin-bottom: 0;

    & > a {
      font-weight: bold;
      font-size: 1rem;
      color: #286090;
      margin-right: 0;
      border-left: 0;
    }
  }

  li.active a,
  li.active a:focus,
  li.active a:hover {
    background: @accentColor;
    color: white;
    border: 1px solid @accentColor;
  }

  li.disabled a,
  li.disabled a:focus,
  li.disabled a:hover {
    background: #efefef;
    color: #999999;
    border-color: white;
    font-style: italic;
    font-weight: normal;
  }

  .default {
    font-style: normal;
  }
}
.tab-description {
  min-height: 4em;
}
h2 {
  line-height: 36px;
  text-align: center;
  margin-bottom: 20px;

  .student-name {
    font-style: italic;
    color: #3c9ad5;
  }
}
.ai-logo {
  margin-left: 1em;
}
</style>
